// extracted by mini-css-extract-plugin
export default {"content":"ExpandableProductAdditionalInfo__content___q4EKv"};